
export const USER_CONFIG ={
    token:'UT',
    loggedUser:'LU',
    clienteFormulario:'CF'
}


// WEBPACK FOOTER //
// ./src/config/UserConfig.js